import { combineReducers } from "@reduxjs/toolkit";
import { authInfoReducer } from "@/features/yard360/store/authInfo/reducer";
import { featureFlagsReducer } from "@/features/yard360/store/featureFlags/reducer";
import { buildingCodesReducer } from "@/features/yard360/store/buildingCodes/reducer";
import { wranglingReportReducer } from "@/features/yard360/store/wranglingReport/reducer";
import { equipmentReportReducer } from "@/features/yard360/store/equipmentReport/reducer";
import { permissionsReducer } from "@/features/yard360/store/permissions/reducer";
import navigationReducer from "@/features/yard360/NavigationTabs/slice";
import { api } from "@/services/api";
import yardDetectionDataReducer from "@/features/relayYardControl/store/yardDetectionData/slice";
import yardMovesReducer from "@/features/relayYardControl/store/yardMoves/slice";
import websocketReducer from "@/services/websocket/slice";
import ryteDataReducer from "@/features/ryteTracker/store/ryteDataSlice";

const rycReducers = {
  [api.reducerPath]: api.reducer,
  featureFlags: featureFlagsReducer,
  // WebSocket
  websocket: websocketReducer,
  // mereged data between alert, visit, job
  yardDetectionData: yardDetectionDataReducer,
  // Flat Record<moveId, YardMove> populated by RTK Query + WebSocket updates
  yardMoves: yardMovesReducer,
  // Normalized RYTE entity state (goals, visits, appointments)
  ryteData: ryteDataReducer,
};

const yard360Reducers = {
  // Existing reducers (Yard 360)
  authInfo: authInfoReducer,
  buildingCodeData: buildingCodesReducer,
  wranglingReport: wranglingReportReducer,
  equipmentReport: equipmentReportReducer,
  navigation: navigationReducer,
  permissions: permissionsReducer,
};
const rootReducer = combineReducers({
  ...yard360Reducers,
  ...rycReducers,
});

export default rootReducer;
